import React, { useEffect } from 'react';
import classnames from 'classnames';
import styles from '../editContactModal.module.scss';
import { Form } from 'react-bootstrap';
import { ContactFormProps } from 'v2/models';
import FormLabel from 'v2/form/FormLabel/FormLabel';

const ContactAddressForm = ({ register, fieldsRef }: ContactFormProps) => {
  useEffect(() => {
    fieldsRef?.address?._f.ref.focus?.();
  }, []);
  return (
    <div className={classnames(styles.descriptionForm)}>
      <span className={styles.titleDescription}>
        Enter an address for this contact
      </span>
      <FormLabel label={`Address`} required={false} />
      <Form.Control
        as="textarea"
        rows={5}
        aria-label="contact-address-input"
        autoComplete="off"
        {...register?.('address', { required: false })}
      />
    </div>
  );
};

export default ContactAddressForm;
